"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _commonCta = require("@mmc/common-cta");
var _debounce2 = _interopRequireDefault(require("lodash/debounce"));
var _clsx5 = _interopRequireDefault(require("clsx"));
var _floatingBottomMenu = _interopRequireDefault(require("./floating-bottom-menu.css"));
var _floatingBottomMenu2 = _interopRequireDefault(require("./floating-bottom-menu.props/floating-bottom-menu.defaultProps"));
var _floatingBottomMenu3 = _interopRequireDefault(require("./floating-bottom-menu.props/floating-bottom-menu.propTypes"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FloatingBottomMenu = function FloatingBottomMenu(_ref) {
  var _clsx, _clsx2, _clsx4;
  var className = _ref.className,
    data = _ref.data,
    theme = _ref.theme;
  var _useState = (0, _react.useState)(false),
    isQuickLinksOpen = _useState[0],
    setIsQuickLinksOpen = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    quickLinks = _useState2[0],
    setQuickLinks = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    staticLeftButton = _useState3[0],
    setStaticLeftButton = _useState3[1];
  var _useState4 = (0, _react.useState)(true),
    isFloatingMenuVisible = _useState4[0],
    setIsFloatingMenuVisible = _useState4[1];

  // Set final array for UI with static left button & quick links
  (0, _react.useEffect)(function () {
    var _data$ctas;
    if (((_data$ctas = data.ctas) == null ? void 0 : _data$ctas.length) > 0) {
      setQuickLinks(getCtasWithStaticLeftButton(data.ctas));
    }
  }, [data]);

  // Scroll effect to trigger hide/show for floating menu when the user is near the bottom of the page
  (0, _react.useEffect)(function () {
    var handleScroll = (0, _debounce2["default"])(function () {
      var footer = document.querySelector('footer');
      if (footer) {
        var footerTop = footer.getBoundingClientRect().top;
        var windowHeight = window.innerHeight;
        if (footerTop <= windowHeight) {
          setIsFloatingMenuVisible(false);
        } else {
          setIsFloatingMenuVisible(true);
        }
      }
    }, 10);
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Handle toggle show/hide floating menu
  var handleOpenQuickLinks = function handleOpenQuickLinks(label) {
    setIsQuickLinksOpen(!isQuickLinksOpen);
    handleQuickLinkEvent(label);
  };
  var handleQuickLinkEvent = function handleQuickLinkEvent(label) {
    var _window;
    var event = label === 'CLOSE' || label === 'OPEN' ? 'clickevent' : 'linkclickevent';
    var modelName = '';
    if (window.location && window.location.pathname) {
      var pathnames = window.location.pathname.split('/');
      var pathnamePosition = pathnames.length >= 3 ? 2 : 1;
      // eslint-disable-next-line prefer-destructuring
      modelName = pathnames[pathnamePosition];
    }
    (_window = window) == null || (_window = _window.dataLayer) == null || _window.push({
      event: event,
      section_name: 'Floating',
      component: 'Floating',
      action: 'Quick Links Menu',
      click_text: label,
      nameplate: modelName
    });
  };
  var getCtasWithStaticLeftButton = function getCtasWithStaticLeftButton(ctas) {
    var STATIC_BUTTON_ALIGNMENT = 'left';
    var newCtas = ctas.map(function (cta) {
      return _objectSpread(_objectSpread({}, cta), {}, {
        url: cta.link,
        priority: 'lowIcon'
      });
    });
    var staticButton = newCtas.find(function (cta) {
      return cta.ctaAlignment === STATIC_BUTTON_ALIGNMENT;
    }) || undefined;
    if (staticButton) {
      setStaticLeftButton(staticButton);
      newCtas = [].concat(newCtas.filter(function (cta) {
        return cta.ctaAlignment !== STATIC_BUTTON_ALIGNMENT;
      }));
    }
    return newCtas;
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx5["default"])(_floatingBottomMenu["default"].floatingButtonContainer, className, (_clsx = {}, _clsx[_floatingBottomMenu["default"].floatingMenuHidden] = !isFloatingMenuVisible, _clsx))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx5["default"])(_floatingBottomMenu["default"].menu, (_clsx2 = {}, _clsx2[_floatingBottomMenu["default"].visible] = isQuickLinksOpen, _clsx2))
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: _floatingBottomMenu["default"].ctas
  }, quickLinks.map(function (cta, index) {
    var _clsx3;
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: index,
      style: {
        width: 100 / cta.length + "%"
      }
    }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: _objectSpread(_objectSpread({}, cta), {}, {
        url: cta.link
      }),
      theme: theme,
      "data-section": "quick-links",
      spanClasses: (0, _clsx5["default"])(theme.black),
      classes: (0, _clsx5["default"])(theme.labelMedium, theme.black, _floatingBottomMenu["default"].cta, (_clsx3 = {}, _clsx3[_floatingBottomMenu["default"].icon] = cta.icon, _clsx3)),
      clickEvent: function clickEvent() {
        return handleQuickLinkEvent(cta.label);
      },
      iconRight: true
    }));
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _floatingBottomMenu["default"].overlay
  }, staticLeftButton && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    data: staticLeftButton,
    theme: theme,
    "data-section": "static-button",
    spanClasses: (0, _clsx5["default"])(theme.black),
    classes: (0, _clsx5["default"])(theme.labelMedium, theme.grey, _floatingBottomMenu["default"].cta, _floatingBottomMenu["default"].staticButton, (_clsx4 = {}, _clsx4[_floatingBottomMenu["default"].icon] = staticLeftButton.icon, _clsx4)),
    clickEvent: function clickEvent() {
      return handleQuickLinkEvent(staticLeftButton.label);
    },
    iconRight: true
  }), !isQuickLinksOpen ? /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return handleOpenQuickLinks('OPEN');
    },
    className: (0, _clsx5["default"])(_floatingBottomMenu["default"].cta, _floatingBottomMenu["default"].dark, _floatingBottomMenu["default"].openQuickLinks)
  }, data == null ? void 0 : data.label) : /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return handleOpenQuickLinks('CLOSE');
    },
    className: (0, _clsx5["default"])(_floatingBottomMenu["default"].cta, _floatingBottomMenu["default"].close, _floatingBottomMenu["default"].dark)
  }, "X")));
};
FloatingBottomMenu.defaultProps = {
  data: _floatingBottomMenu2["default"],
  defaultData: _floatingBottomMenu2["default"]
};
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    market: props.market || state.Config.market,
    language: props.language || state.Config.language
  };
};
FloatingBottomMenu.resourceType = function () {
  return 'FloatingBottomMenu_1_0_0';
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(FloatingBottomMenu);